import React, { useMemo } from "react";
import styled from "@emotion/styled";
import get from "lodash.get";
import { useIntl } from "react-intl";

import { Paper } from "@mui/material";

import ParkkiTheme from "themes/ParkkiTheme";

import Abilities from "services/permissions/abilities";
import CommonUtils from "services/common/utils";
import VisitorCharacteristicsUtils from "services/visitorCharacteristics/utils";

import Placeholder from "components/Placeholder";
import LineMultiPercentage from "components/LineMultiPercentage";
import Section from "components/Section";
import ToggleButtonGroup from "components/ToggleButtonGroup";

const ToggleButtonGroupContainer = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 10px;
`;
const GraphSection = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: row;
  padding: ${ParkkiTheme.spacings.base};
`;

const GraphsContainer = styled.div`
  display: flex;
  flex: 1;
  justif-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
  height: 100%;
`;

function QualitificationDestinationSection({
  destinationsDistribution,
  visitorCharacteristics,
  setQualificationDestinationFilters,
}) {
  const intl = useIntl();

  const chartTooltip = useMemo(() => {
    if (!destinationsDistribution) {
      return null;
    }

    return intl.formatMessage(
      {
        id: "visitorCharacteristicsScene.sections.qualificationTime.destinationInfoTooltip",
      },
      {
        duration: CommonUtils.humanizeDateFromDuration(
          destinationsDistribution,
          "minutes",
          intl,
          false
        ),
      }
    );
  }, [intl, destinationsDistribution]);

  const qualificationDestinationCharts =
    VisitorCharacteristicsUtils.getQualificationDestinationChart(
      get(visitorCharacteristics, "qualificationDestination"),
      get(visitorCharacteristics, "filters.areas"),
      intl
    );

  const options = new Array(7).fill(0).map((item, index) => ({
    label: intl.messages[`daysOfWeek.${index}`],
    value: index + 1,
  }));
  const selectedDays =
    get(visitorCharacteristics, "qualificationDestination.filters.dow") &&
    Array.isArray(
      get(visitorCharacteristics, "qualificationDestination.filters.dow")
    )
      ? get(visitorCharacteristics, "qualificationDestination.filters.dow")
      : [get(visitorCharacteristics, "qualificationDestination.filters.dow")];

  return Abilities.ability.can(
    "read",
    "visitorCharacteristics.destinationsDistribution"
  ) ? (
    <Section
      title={
        intl.messages[
          "visitorCharacteristicsScene.sections.qualificationDestination.title"
        ]
      }
      infoTooltip={chartTooltip}
    >
      <ToggleButtonGroupContainer>
        <ToggleButtonGroup
          loading={!visitorCharacteristics.qualificationDestination.initialized}
          options={options}
          value={selectedDays || []}
          onChange={(e, value) => {
            if (
              value === null ||
              (Array.isArray(value) && value.length === 0)
            ) {
              return null;
            }
            return setQualificationDestinationFilters({ dow: value });
          }}
        />
      </ToggleButtonGroupContainer>

      {!visitorCharacteristics?.qualificationDestination?.initialized ? (
        <Placeholder height="180px" />
      ) : null}

      {visitorCharacteristics?.qualificationDestination?.initialized ? (
        <GraphSection>
          <GraphsContainer>
            <LineMultiPercentage data={qualificationDestinationCharts} />
          </GraphsContainer>
        </GraphSection>
      ) : null}
    </Section>
  ) : null;
}

export default QualitificationDestinationSection;
